export default __webpack_public_path__ + "static/media/ARQRcode.cdfd52aa.png";